import { render } from "./IacWithAzureBicep.vue?vue&type=template&id=24209934&scoped=true"
import script from "./IacWithAzureBicep.vue?vue&type=script&lang=js"
export * from "./IacWithAzureBicep.vue?vue&type=script&lang=js"

import "./IacWithAzureBicep.vue?vue&type=style&index=0&id=24209934&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24209934"]])

export default __exports__